import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import React from 'react';
import { base64ToDataUrl, blobToFile, dataUrlToFile, uInt8ToFile } from "../../utils";
import { ViewArchiveErrorType } from "../view-archive.vm";
import { getBlobUrl } from "../../hooks";
export const useArchiveFile = (archive, name) => {
  const {
    file,
    blob,
    httpUrl,
    staticUrl,
    dataUrl,
    base64,
    uInt8
  } = archive;
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [archiveFile, setArchiveFile] = React.useState(null);
  const urlToFile = React.useCallback((url, archiveName, config) => {
    setLoading(true);
    getBlobUrl(url, config).then(({
      data
    }) => setArchiveFile(blobToFile(data, archiveName))).catch(() => setError(ViewArchiveErrorType.DOWNLOAD_ERROR)).finally(() => setLoading(false));
  }, []);
  React.useEffect(() => {
    const archiveName = name !== null && name !== void 0 ? name : new Date().getTime().toString();
    if (file) setArchiveFile(file);else if (blob) setArchiveFile(blobToFile(blob, archiveName));else if (httpUrl) urlToFile(httpUrl.url, archiveName, httpUrl.config);else if (dataUrl) setArchiveFile(dataUrlToFile(dataUrl, archiveName));else if (base64) setArchiveFile(dataUrlToFile(base64ToDataUrl(base64.data, base64.mime), archiveName));else if (uInt8) setArchiveFile(uInt8ToFile(uInt8.data, uInt8.mime, archiveName));else if (staticUrl) urlToFile(staticUrl.url, archiveName);else setError(ViewArchiveErrorType.NO_ARCHIVE);
    setLoading(false);
  }, [archive, name]);
  return [archiveFile, {
    error,
    loading
  }];
};